import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITopTenSidebar } from '../models/common';
import { ToptenEndpoint } from '../endpoints/topten';
import { map } from 'rxjs/operators';
import { StringUtil } from '@shared/utils';
/**
 * ### **ToptenService**
 *
 * Un Servicio en Angular es el mecanismo para compartir funcionalidad entre componentes,
 * en este caso se encarga de compartir las funciones del top 10 que hacen diferentes peticiones o
 * llamados a distintos API's que genera el backend.
 * */
@Injectable({
  providedIn: 'root',
})
export class Topten {
  private readonly http = inject(HttpClient);

  /** @ignore*/
  constructor() {}

  /**
   * función encargad ad e obtener el sidebar que sera renderizado en el landing de busqueda,
   * sin embargo antes de devolver el resultado, se aplican una serie de opradores de ngrx, para
   * trabajar con el resultado del observable y obtener los items y subtitulos de los mismos.
   */
  getSidebar(): Observable<ITopTenSidebar> {
    return this.http.get<ITopTenSidebar>(ToptenEndpoint.sidebar).pipe(
      map((sidebar) => {
        sidebar.items = sidebar.items.map((items) => {
          if (items.label.language) {
            items.label.language.slug = StringUtil.slugify(items.label.language.title);
          }
          if (items.subtitle) {
            items.subtitle = items.subtitle.map((subtitle) => {
              if (subtitle.label && subtitle.label.language) {
                subtitle.label.language.slug = StringUtil.slugify(subtitle.label.title);
              }
              return subtitle;
            });
          }
          return items;
        });
        return sidebar;
      })
    );
  }
}
